var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TalentAttribute } from 'packages/talent/entities/TalentAttribute';
var JobAttachedAttribute = /** @class */ (function (_super) {
    __extends(JobAttachedAttribute, _super);
    function JobAttachedAttribute() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isRequired = false;
        _this.requiredValue = null;
        _this.isIdeal = false;
        _this.idealValue = null;
        _this.disqualifyOnFailure = false;
        return _this;
    }
    return JobAttachedAttribute;
}(TalentAttribute));
export { JobAttachedAttribute };
